import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import BillingForm from './BillingForm';
import { fetchWithCorpId } from '../utils/api';

function BillingFormScreen({ mode, onSuccess, onCancel }) {
  const { id } = useParams();
  const [billingData, setBillingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBilling = async () => {
      if (mode === 'edit' && id) {
        setLoading(true);
        try {
          const data = await fetchWithCorpId(`/billing/${id}`);
          setBillingData(data);
        } catch (err) {
          console.error('Error fetching billing:', err);
          setError('Failed to load billing data');
        } finally {
          setLoading(false);
        }
      }
    };

    fetchBilling();
  }, [mode, id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div style={{ padding: '20px' }}>
      <BillingForm
        mode={mode}
        initialData={billingData}
        onSuccess={onSuccess}
        onCancel={onCancel}
      />
    </div>
  );
}

export default BillingFormScreen;
